<template>
  <qc-container title="客户管理">
    <page-request ref="table" url="/api/mgr/business/shop/customer/list" :table-header="tableHeader" :expend="expend"
                  :prop="{goodsType:0,orgId:orgId}" :op-width="200">
      <template #op="scope">
        <b-button @click="doShowSetRemark(scope.row)">备注</b-button>
        <b-button @click="toDetail(scope.row)">查看详情</b-button>
      </template>
    </page-request>
  </qc-container>
  <user-detail ref="userDetail"></user-detail>
  <set-remark ref="remark" @load="pageReloadData"></set-remark>
</template>

<script>
import QcContainer from "@/components/el/layout/qc-container.vue";
import BButton from "@/components/el/b-button.vue";
import TButton from "@/components/el/t-button.vue";
import PageRequest from "@/components/base/page-request.vue";
import UserDetail from "@view/user/op/user-detail.vue";
import SetRemark from "@org/customer/components/set-remark.vue";

export default {
  props:{
    orgId:{
      type:String
    }
  },
  name: "org-finance-list",
  components: {SetRemark, UserDetail, PageRequest, TButton, BButton, QcContainer},
  data() {
    return {
      tableHeader: [
        {type:"user", label: "客户",width:300},
        {prop:"phone", label: "电话",width:200},
        {prop: "remark", label: "备注"}
      ],
      expend: [
        {label: "名称", prop: "nickname"},
        {label: "电话", prop: "phone"},
      ],
    }
  },
  mixins: [tableBase],
  methods: {
    doShowSetRemark(row){
      this.$refs.remark.open(row.id,row.remark);
    },
    toDetail(row){
      this.toRouter('/index/org/customer/detail',{id:row.userId});
    }
  },
  mounted() {

  }
}
</script>

<style scoped>

</style>
